import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.number.isRequired,
  full_name: PropTypes.string.isRequired,
  patients_count: PropTypes.number.isRequired
});
